<template>
    <app-modal unique="view-country" title="View Country Details">

        <form @submit.prevent="confirmUpdateCountry">
            <div class="form-group form-row mb-1" :class="{'has-error': countryErrors.code}">
                <label for="country-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="country-code" class="form-control form-control-xs"
                           placeholder="No Country Code Yet"
                           :readonly="!editable"
                           v-model="country.code"
                    >
                    <span class="help-block" v-if="countryErrors.code !== ''">
                      <small><strong>{{ countryErrors.code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': countryErrors.name}">
                <label for="country-name" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country Name:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="country-name" class="form-control form-control-xs"
                           placeholder="No Country Name Yet"
                           :readonly="!editable"
                           v-model="country.name"
                    >
                    <span class="help-block" v-if="countryErrors.name !== ''">
                      <small><strong>{{ countryErrors.name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': countryErrors.natl}">
                <label for="country-nationality" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Nationality:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="country-nationality" class="form-control form-control-xs"
                           placeholder="No Nationality Yet"
                           :readonly="!editable"
                           v-model="country.natl"
                    >
                    <span class="help-block" v-if="countryErrors.natl !== ''">
                      <small><strong>{{ countryErrors.natl }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': countryErrors.natl_code}">
                <label for="country-natl-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Nationality Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="country-natl-code" class="form-control form-control-xs"
                           placeholder="No Nationality Yet"
                           :readonly="!editable"
                           v-model="country.natl_code"
                    >
                    <span class="help-block" v-if="countryErrors.natl_code !== ''">
                      <small><strong>{{ countryErrors.natl_code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': countryErrors.active }">
                <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="country-status" >
                    Status:
                </label>

                <div class="col col-sm-8">
                  <select class="form-control form-control-xs" id="country-status" v-model="country.active"
                    :disabled="!editable"
                  >
                    <option :value="1" >ACTIVE</option>
                    <option :value="0">INACTIVE</option>
                  </select>
                    <span class="help-block" v-if="countryErrors.active !== ''">
                    <small><strong>{{ countryErrors.active }}</strong></small>
                </span>
                </div>
            </div>

            <hr />
            <div class="text-right">
                <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder" v-if="!guest"
                        :key="'edit-country'"
                >
                    <i class="fas fa-edit"></i>
                    {{ editable ? 'Update' : 'Edit' }}
                </button>
                <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                        v-if="editable"
                        @click="cancelEdit"
                >
                    <span class="fas fa-ban"></span>
                </button>
            </div>

        </form>


    </app-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
    name: "ViewCountry",

    components: { AppModal },

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    props: {
        viewCountry: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            country: {},
            countryErrors: {},
            editable: false
        }
    },

    methods: {
        ...mapActions([
            'updateCountry'
        ]),

        async confirmUpdateCountry() {
            if(this.editable) {
                if(await this.confirmUpdate()) {
                    let updatedCountry = await this.updateCountry(this.country);
                    if(updatedCountry) {
                        if(updatedCountry.errors) {
                            this.countryErrors = updatedCountry.errors;
                        } else {
                            this.successAlert('Country Successfully Updated', 'UPDATE')
                            document.getElementById('close-view-country').click();
                        }
                    } else {
                        this.errorAlert('Failed to Update Country Details', 'UPDATE');
                    }
                }
            } else {
                this.editable = true;
            }
        },

        cancelEdit() {
            this.editable = false;
            this.country = Object.assign({}, this.viewCountry);
        }

    },

    computed: {

    },

    watch: {
        viewCountry() {
            this.country = Object.assign({}, this.viewCountry);
            this.editable = false;
        }
    }


}
</script>

<style scoped>

</style>
